import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Response } from '@angular/http';
import { Alert, AlertService, EventManager } from 'ng-jhipster';
import { TranslateService } from 'ng2-translate';
import { Observable } from 'rxjs';
import { Principal } from '../../shared/auth/principal.service';
import { UtilsService } from '../../shared/utils/utils.service';
import { CampaignService } from '../campaign/campaign.service';
import { SaisineComment, SaisineCommentType } from '../saisine-comment/saisine-comment.model';
import { PropertiesService } from './properties.service';
import { Saisine, SaisineStatus } from './saisine.model';
import { SaisineService } from './saisine.service';



@Component({
    selector: 'jhi-saisine-comment',
    templateUrl: './saisine-comment.component.html'
})
export class SaisineCommentComponent implements OnInit {
    @Input() saisine: Saisine;
    saisineComments: SaisineComment[];
    saisineComment: SaisineComment;
    maxNbComments: number;

    @Input() type: SaisineCommentType;
    types: any = SaisineCommentType;

    @Output() saisineChange = new EventEmitter();

    @ViewChild('saisineCommentForm') saisineCommentForm: NgForm;

    formError: string;

    isSaving: boolean;
    alert: Alert;
    constructor(
        public principal: Principal,
        private alertService: AlertService,
        public saisineService: SaisineService,
        public utilsService: UtilsService,
        private translateService: TranslateService,
        public campaignService: CampaignService,
        public propertiesService: PropertiesService, private eventManager: EventManager) {
        this.maxNbComments = this.propertiesService.properties.maxNbComments;
    }

    ngOnInit() {
        this.saisineComment = new SaisineComment;
    }

    comments() {
        return this.saisine.saisineComment.filter(c => c.type === this.types[this.type]);
    }

    commentUser(comment: SaisineComment) {
        return comment.userEmail ? comment.userEmail : this.translateService.instant('tmmsaisineApp.comment.rectorat');
    }

    hideAddComment() {
        return (this.type === SaisineCommentType.RECTORAT_TO_STUDENT && this.saisine.status === SaisineStatus.CANCELED);
    }

    addCommentTitle() {
        if (this.principal.hasSyncAuthority('ROLE_STUDENT')) {
            return 'tmmsaisineApp.comment.form.titles.student';
        }
        return 'tmmsaisineApp.comment.form.titles.internal.' + this.types[this.type];
    }

    addSaisineComment(saisineId: number) {
        this.alert && this.eventManager.broadcast({ name: 'tmmsaisineApp.closeAlert', content: this.alert });
        this.formError = undefined;
        this.isSaving = true;
        this.saisineComment.type = this.types[this.type];
        let resp: Observable<Response>;
        if (this.principal.hasSyncAuthority('ROLE_STUDENT')) {
            resp = this.saisineService.addStudentSaisineComment(this.saisineComment);
        } else {
            resp = this.saisineService.addSaisineComment(saisineId, this.saisineComment);
        }
        resp.subscribe(
            this.onSaveSuccess,
            this.onSaveError
        );
    }

    // this binding
    onSaveSuccess = () => {
        this.isSaving = false;
        this.saisineChange.emit();
        this.saisineCommentForm.reset();
    }

    onSaveError = (error) => {
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.formError = error.headers && error.headers._headers && error.headers._headers.get('x-tmmsaisineapp-error');
        this.alert = this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine-comment.component.ts